module.exports = __webpack_public_path__ + "static/media/rm_06-26.75a452bb.png";